<template>
    <div>
        <div class="row">
            <div class="col-lg-12">
                <table class="table table-striped table-sm table-hover">
                    <thead class="bg-primary text-white">
                    <tr>
                        <th scope="col">
                            Kulcs
                        </th>
                        <th scope="col">
                            Érték
                        </th>
                        <th scope="col"></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="dict in dictionaries">
                        <th scope="row">{{dict.key}}</th>
                        <td>{{dict.value}}</td>
                        <td>
                            <button type="submit" class="btn btn-sm btn-primary" @click="editDictionary(dict)">
                                <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
                            </button>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="card mb-2">
            <div class="card-header">
                <div class="collapsed card-link" data-parent="#accordion">
                    {{ inputHeader }}
                </div>
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="col-lg-6 col-xl-3">
                        <div class="form-group">
                            <label for="key" class="sr-only">Kulcs</label>
                            <div class="input-group mb-2 mr-sm-2 mb-sm-0">
                                <input
                                    id="key"
                                    type="text"
                                    class="form-control form-control-sm"
                                    v-model="inputValue.key"
                                    placeholder="Kulcs*"
                                    :disabled="mode === 'edit'"
                                    required
                                >
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-12 col-xl-12">
                        <div class="form-group">
                            <label for="value" class="sr-only">Érték</label>
                            <div class="input-group mb-2 mr-sm-2 mb-sm-0">
                                <textarea
                                    id="value"
                                    class="form-control form-control-sm"
                                    v-model="inputValue.value"
                                    placeholder="Érték*"
                                    :disabled="isLoading"
                                    required
                                >
                                </textarea>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-3 col-xl-2">
                        <button type="submit" class="btn btn-primary btn-block" @click.prevent="saveDictionary"
                                :disabled="isLoading">
                            <i class="fa fa-save"></i>
                            Mentés
                        </button>
                    </div>
                    <div class="col-lg-3 col-xl-2">
                        <button v-if="mode === 'edit'" type="submit" class="btn btn-primary btn-block" @click.prevent="cancelEdit"
                                :disabled="isLoading">
                            Mégsem
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    const NewDictionaryHeader = 'Új beállítás';
    const EditDictionaryHeader = 'Beállítás módosítása';

    export default{
        name: 'DictionaryController',
        data(){
            return {
                dictionaries: [],
                inputValue: {},
                mode: 'new',
                inputHeader: NewDictionaryHeader,
                isLoading: false
            }
        },
        watch: {
            mode(){
                if(this.mode === 'new'){
                    this.inputHeader = NewDictionaryHeader;
                    this.resetInputValue();
                } else if(this.mode === 'edit'){
                    this.inputHeader = EditDictionaryHeader;
                }
            }
        },
        methods: {
            resetInputValue(){
                this.inputValue = {
                    key: '',
                    value: ''
                }
            },
            loadData(){
                this.$store.dispatch('DictionaryModul/getDictionaryList', {
                    filter: this.filter,
                    order: this.order,
                    result: (res)=> {
                        this.dictionaries = [];
                        res.data.dictionaryList.forEach(dict => {
                            this.dictionaries.push({
                                key: dict.code_key,
                                value: dict.value
                            });
                        });
                    }
                });
            },
            saveDictionary(){
                let action = this.mode === 'new' ? 'DictionaryModul/saveDictionary' : 'DictionaryModul/editDictionary';
                this.$store.dispatch(action,{
                    data: this.inputValue,
                    result: (res) => {
                        this.resetInputValue();
                        this.loadData();
                        this.mode = 'new';
                    },
                    reject: (rej) => {

                    }
                })
            },
            editDictionary(dict){
                this.mode = 'edit';
                this.inputValue = Object.assign({}, dict);
            },
            cancelEdit(){
                this.resetInputValue();
                this.mode = 'new';
            }
        },
        mounted(){
            this.loadData();
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/admin/DictionaryController.vue